import { useSelector } from 'react-redux';
import { Creator } from '~/clientApi/creator.model';
import { CREATOR_MANAGER_RELATION } from '~/constants/creatorManagerRelation';
import { selectTalentManager } from '~/selectors/talent-manager';
import { CreatorType, ICreator, ManagerType } from '~/types';

export const getCreatorManagerRelation = (
  creator: ICreator | Creator | CreatorType,
  manager?: ManagerType,
): string | null => {
  if (!creator || !creator.agency || !manager) {
    return null;
  }

  if (creator.manager?.id === manager?.id) {
    // creator.isManagerOwner returns true only if creator has co-managers
    // We access the manager entity instead, to check if the manager is the owner in all cases
    return CREATOR_MANAGER_RELATION.manager;
  }

  if (creator.isCoManager) {
    // TODO: creator.agency.id not returned currently in `/managers/id/creators`.
    // Until this will be done, this will return externalCoManager for a creator shared with me, internally or externally.
    return creator?.agency.id !== manager?.agency.id
      ? CREATOR_MANAGER_RELATION.externalCoManager
      : CREATOR_MANAGER_RELATION.coManager;
  }

  return creator?.agency.id !== manager?.agency.id
    ? CREATOR_MANAGER_RELATION.fromExternalAgencyTeam
    : CREATOR_MANAGER_RELATION.inOwnAgencyTeam;
};

export const useCurrentUserCreatorRelation = (
  creator: ICreator | Creator | CreatorType,
): string | null => {
  const manager = useSelector(selectTalentManager);
  return getCreatorManagerRelation(creator, manager);
};
